import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const imageUrl = (id) => `${API}/images/${id}`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("mpf_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default client;
